import { useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { StateMachineProvider, createStore, useStateMachine } from 'little-state-machine';
import styled, { createGlobalStyle } from 'styled-components';

import { BASE_URL } from 'v6/Constant';
import Header from 'v6/Components/Header';
import CreateAccountForm from 'v6/Pages/Homepage/Homepage';
import ChooseTrial from 'v6/Pages/ChoosePlan/ChooseTrial';
import PaymentDetails from 'v6/Pages/PaymentDetails/PaymentDetails';
import StartTrial from 'v6/Pages/StartTrial';

import { FormDataProps } from 'utils/types';
import { BREAKPOINTS } from 'constants/common';
import { ScrollToTop } from 'Components/ScrollToTop';



const GlobalStyle = createGlobalStyle`
  body {
    --primary: #4F31FF;
    --gray: #C4C4C4;
    --errorRed: #fa4f38;
    --green: #10b981;
    --lightGreen: #E7F8F2;
    --black: #333333;
    --textGray: #808080;
    --errorLightBackground: #FFF8F8;
    --white: #FFFFFF;
    --greenLightBackground: #F5FFFA;
    --lightBlueBackground: #F6F5FF;
    --defaultBorderColor: #e6e6e6;
    --gothamFonts: "Gotham SSm A", "Gotham SSm B";
    --Brand-Spice-50: #FFF4EC;
    --text-text-primary: #333333;
    --Colour-Blue-700: #0E1680;
    --Brand-Cosmo-500: #ED207C;
    --Brand-Grape-800: #642A73;
  }
`;

createStore({}, {});

function PrivateRoute({ children, canNavigate, redirectPath, ...rest }: any) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        canNavigate ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: redirectPath,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function Routers() {
  const { state } = useStateMachine();
  const defaultValuesFromStorage = state as FormDataProps;
  const accountFormIsComplete = useMemo(
    () =>
      [
        'firstName',
        'lastName',
        'companyName',
        'email',
        'password',
        'tos',
        'numberAccounts',
        // @ts-ignore
      ].every((field: string) => defaultValuesFromStorage[field]),
    [defaultValuesFromStorage],
  );
  const choosePlanIsComplete = useMemo(
    () =>
      accountFormIsComplete &&
      ['selectedPlanId', 'currency'].every(
        // @ts-ignore
        (field: string) => defaultValuesFromStorage[field],
      ),
    [accountFormIsComplete, defaultValuesFromStorage],
  );

  return (
    <Router basename={BASE_URL}>
      <ScrollToTop />
      <GlobalStyle />
      <Header />
      <ContentWrap>
        <Route exact path="/" component={CreateAccountForm} />
        <Route exact path="/account" component={CreateAccountForm} />
        <PrivateRoute exact path="/plan" canNavigate={accountFormIsComplete} redirectPath="/">
          <ChooseTrial />
        </PrivateRoute>
        <PrivateRoute exact path="/payment" canNavigate={choosePlanIsComplete} redirectPath="/plan">
          <PaymentDetails />
        </PrivateRoute>
        <PrivateRoute exact path="/start-trial" canNavigate={true} redirectPath="/payment">
          <StartTrial />
        </PrivateRoute>
      </ContentWrap>
    </Router>
  );
}

function App() {
  useEffect(() => {
    const isLoggedIn: Boolean = !!Cookies.get('sked.session_id') && !!Cookies.get('connect.sid');

    if (isLoggedIn) {
      window.location.href = '/dashboard';
    }
  }, []);

  return (
    <StateMachineProvider>
      <Routers />
    </StateMachineProvider>
  );
}

export default App;

const ContentWrap = styled.div`
  margin: 100px 0 0px;
`;
